import type { BetterAuthClientPlugin } from 'better-auth/client';
import { emailOTPClient, adminClient } from 'better-auth/client/plugins';
import { toroAccountClientPlugin } from './plugins/toroAccountPlugin.js';
export { authCookiePrefix as cookiePrefix } from '@repo/common/config';

// Client plugins should be listed here
export const clientPlugins = [
  toroAccountClientPlugin,
  emailOTPClient(),
  adminClient(),
] as const satisfies BetterAuthClientPlugin[];

export const basePath = '/api/auth';
